<template>
  <div class="subscription-page">
    <div class="container">
      <div class="content-wrapper">
        <h1 class="page-title">Services Content</h1>

        <!-- Registration Form -->
        <div class="registration-step">
          <p class="instruction-text">Enter your number to register</p>

          <div class="phone-input-container">
            <div class="country-code">
              <span class="flag">🇧🇩</span>
              <span class="code">+88</span>
            </div>
            <input
              type="tel"
              v-model="phoneNumber"
              placeholder="01917748626"
              class="phone-input"
              maxlength="11"
            />
          </div>

          <div class="select-container">
            <select v-model="selectedChannel" class="channel-select">
              <option value="" disabled>Select your channel</option>
              <option
                v-for="channel in channels"
                :key="channel.value"
                :value="channel.value"
              >
                {{ channel.text }}
              </option>
            </select>
          </div>

          <button
            class="send-button"
            @click="submitRegistration"
            :disabled="loading"
          >
            {{ loading ? "Processing..." : "Send" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BILLING } from "../../http-common";

export default {
  name: "Subscription",
  data() {
    return {
      phoneNumber: "",
      selectedChannel: "",
      channels: [
        { text: "Bkash", value: "47090" },
        { text: "Banglalink", value: "47003" },
        { text: "Grameenphone", value: "47001" },
        { text: "Robi", value: "47002" },
      ],
      loading: false,
      gameDetails: {},
    };
  },
  methods: {
    async checkSubscription(productCode) {
      try {
        const response = await BILLING.post("/Detail", {
          msisdn: "88" + this.phoneNumber,
          countryCode: "B43",
          carrierCode: parseInt(this.selectedChannel),
          productCode: productCode,
        });

        return response.data;
      } catch (error) {
        console.error(
          `Error checking subscription for product ${productCode}:`,
          error
        );

        // Check if error is 502
        const is502 = error.response && error.response.status === 502;

        return { error: true, is502, data: error };
      }
    },

    async submitRegistration() {
      if (!this.selectedChannel) {
        this.$swal({
          icon: "warning",
          title: "Channel Required",
          text: "Please select a channel",
        });
        return;
      }
      if (!this.phoneNumber) {
        this.$swal({
          icon: "warning",
          title: "Phone Number Required",
          text: "Please enter your phone number",
        });
        return;
      }

      if (this.phoneNumber.length !== 11) {
        this.$swal({
          icon: "error",
          title: "Invalid Phone Number",
          text: "Please enter a valid 11-digit phone number",
        });
        return;
      }

      this.loading = true;

      try {
        // Check all three product codes: 7, 10, 13
        const productCodes = [7, 10, 13];
        const subscriptionChecks = [];
        let has502Error = false;

        // Check sequentially and break on first 502
        for (const code of productCodes) {
          const result = await this.checkSubscription(code);
          subscriptionChecks.push(result);

          if (result && result.error && result.is502) {
            has502Error = true;
            break;
          }
        }

        console.log("Subscription checks:", subscriptionChecks);

        if (has502Error) {
          // Don't redirect if there's a 502 error
          this.loading = false;
          this.$swal({
            icon: "error",
            title: "Server Error",
            text: "Server error (502) while checking subscription. Please try again later.",
          });
          return;
        }

        // Check if user is subscribed to any product (Status.Code === 50)
        const isSubscribed = subscriptionChecks.some(
          (data) =>
            data && !data.error && data.Status && data.Status.Code === 50
        );

        if (isSubscribed) {
          // User is subscribed - redirect to home
          this.loading = false;
          this.$swal({
            icon: "success",
            title: "Already Subscribed!",
            text: "You are already subscribed to this service.",
            confirmButtonText: "Continue",
          }).then(async () => {
            // await this.downloadGame();
            // setTimeout(() => {
            this.$router.push("/game-details/" + this.selectedGame?.id);
            this.$store.dispatch("ADD_ISSUBSCRIBED", true);
            // }, 3000);
          });
        } else {
          // User is not subscribed - redirect to subscription URL
          this.loading = false;
          const redirectUrl = `https://funbox.zed.com/bangladesh/web/?ms=${this.phoneNumber}&carrier=${this.selectedChannel}`;
          // console.log("User not subscribed, redirecting to:", redirectUrl);
          window.location.href = redirectUrl;
        }
      } catch (error) {
        // If error, show alert
        this.loading = false;
        console.error("Error checking subscriptions:", error);
        this.$swal({
          icon: "error",
          title: "Error",
          text:
            error.message || "Error checking subscription. Please try again.",
        });
      }
    },

    async getGameDetails(id) {
      await this.$api
        .get(`/funbox/${id}`)
        .then((response) => {
          // console.log(response);
          this.gameDetails = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async downloadGame() {
      // console.log(id)
      await this.$api
        .get(`/FunboxDownload/${this.selectedGame?.id}`)
        .then(() => {
          // console.log(response);
          var fileLink = document.createElement("a");
          fileLink.href = "//" + this.selectedGame.Glink.split("//")[1];
          fileLink.setAttribute("download", "apk");
          document.body.appendChild(fileLink);
          fileLink.click();
          // this.gameDetails = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },

  computed: {
    selectedGame() {
      return this.$store.getters.GET_SELECTEDGAME;
    },
  },
};
</script>

<style scoped lang="scss">
.subscription-page {
  min-height: 100vh;
  background-color: #000000;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
}

.content-wrapper {
  padding: 40px 20px;
}

.page-title {
  color: #ff8c00;
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  line-height: 1.2;
}

.page-subtitle {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 400;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 40px;
}

.plans-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 40px;
}

.registration-step {
  margin-top: 60px;
}

.service-info {
  color: #ffffff;
  font-size: 1.3rem;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.6;
  padding: 0 20px;
}

.instruction-text {
  color: #ffffff;
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 30px;
}

.select-container {
  margin-bottom: 20px;
}

.channel-select {
  width: 100%;
  background-color: #f5f5f5;
  border: none;
  border-radius: 12px;
  padding: 20px 25px;
  font-size: 1.2rem;
  color: #333;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 25px center;
  background-size: 20px;
  padding-right: 50px;
  font-weight: 500;

  &:focus {
    box-shadow: 0 0 0 3px rgba(255, 140, 0, 0.2);
  }

  option {
    padding: 10px;
    color: #333;
  }

  option:disabled {
    color: #999;
  }
}

.phone-input-container {
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 20px 25px;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.country-code {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
}

.flag {
  font-size: 1.5rem;
}

.code {
  color: #333;
}

.phone-input {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 1.2rem;
  color: #333;
  outline: none;
  padding: 5px;
  font-weight: 500;

  &::placeholder {
    color: #999;
  }
}

.send-button {
  width: 100%;
  background-color: #ff8c00;
  color: #000000;
  border: none;
  border-radius: 12px;
  padding: 20px;
  font-size: 1.8rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background-color: #e67e00;
    transform: translateY(-2px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.otp-step {
  margin-top: 80px;
}

.otp-info {
  color: #ffffff;
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 40px;
  line-height: 1.8;
  padding: 0 20px;
}

.phone-highlight {
  color: #4a9eff;
  font-weight: 600;
}

.otp-boxes-container {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
}

.otp-box {
  width: 70px;
  height: 70px;
  background-color: #f5f5f5;
  border: none;
  border-radius: 12px;
  font-size: 2rem;
  font-weight: bold;
  color: #000;
  text-align: center;
  outline: none;
  transition: all 0.3s ease;

  &:focus {
    box-shadow: 0 0 0 3px rgba(255, 140, 0, 0.4);
    transform: scale(1.05);
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.otp-timer {
  color: #999;
  font-size: 1.1rem;
  text-align: center;
  margin-top: 20px;
}

.otp-expired {
  color: #ff4444;
  font-size: 1.1rem;
  text-align: center;
  margin-top: 20px;
  font-weight: 600;
}

.otp-input-container {
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 20px 25px;
  margin-bottom: 20px;
}

.otp-input {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 1.5rem;
  color: #333;
  outline: none;
  text-align: center;
  font-weight: 600;
  letter-spacing: 0.5em;

  &::placeholder {
    color: #999;
    letter-spacing: normal;
  }
}

.consent-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.consent-modal {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 30px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.consent-title {
  color: #000000;
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.consent-content {
  color: #333;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 25px;

  p {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.consent-buttons {
  display: flex;
  gap: 15px;
  justify-content: space-between;
}

.consent-btn {
  flex: 1;
  padding: 15px 20px;
  border: none;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;

  &.cancel-btn {
    background-color: #e0e0e0;
    color: #333;

    &:hover {
      background-color: #d0d0d0;
    }
  }

  &.accept-btn {
    background-color: #ff8c00;
    color: #000000;

    &:hover {
      background-color: #e67e00;
    }
  }
}

.plan-card {
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 30px 35px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(255, 140, 0, 0.3);
  }
}

.plan-name {
  color: #ff8c00;
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
  margin-bottom: 8px;
}

.plan-renewal {
  color: #808080;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 400;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 2.5rem;
  }

  .page-subtitle {
    font-size: 1.2rem;
    margin-top: 40px;
  }

  .plan-name {
    font-size: 1.5rem;
  }

  .plan-renewal {
    font-size: 1rem;
  }

  .plan-card {
    padding: 25px 30px;
  }
}

@media (max-width: 480px) {
  .plan-card {
    padding: 25px 30px;
  }

  .service-info {
    font-size: 1.1rem;
  }

  .instruction-text {
    font-size: 1rem;
  }

  .send-button {
    font-size: 1.5rem;
  }

  .channel-select {
    font-size: 1.1rem;
    padding: 18px 20px;
  }

  .consent-modal {
    padding: 25px;
  }

  .consent-title {
    font-size: 1.5rem;
  }

  .consent-content {
    font-size: 0.95rem;
  }

  .otp-info {
    font-size: 1.1rem;
  }

  .otp-boxes-container {
    gap: 12px;
  }

  .otp-box {
    width: 60px;
    height: 60px;
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 2rem;
  }

  .service-info {
    font-size: 1rem;
  }

  .instruction-text {
    font-size: 0.9rem;
  }

  .send-button {
    font-size: 1.3rem;
    padding: 18px;
  }

  .phone-input {
    font-size: 1rem;
  }

  .country-code {
    font-size: 1rem;
  }

  .channel-select {
    font-size: 1rem;
    padding: 16px 20px;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .plan-name {
    font-size: 1.3rem;
  }

  .plan-renewal {
    font-size: 0.9rem;
  }

  .otp-info {
    font-size: 1rem;
  }

  .otp-boxes-container {
    gap: 8px;
  }

  .otp-box {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
  }

  .otp-timer,
  .otp-expired {
    font-size: 1rem;
  }

  .consent-modal {
    padding: 20px;
  }

  .consent-title {
    font-size: 1.3rem;
  }

  .consent-content {
    font-size: 0.9rem;
  }

  .consent-btn {
    font-size: 1rem;
    padding: 12px 16px;
  }
}
</style>
